import { CustomRouteRecordRaw } from 'vue-router'
import EmptyLayout from '@/views/layouts/empty-layout.vue'

export const codeTemplateRoutes: CustomRouteRecordRaw = {
  path: 'codeTemplate',
  name: 'codeTemplate',
  component: EmptyLayout,
  meta: {
    title: '代码模板管理',
    icon: 'file-outlined',
  },
  children: [
    {
      path: 'rafts',
      name: 'rafts',
      component: () => import('@/views/codeTemplate/rafts.vue'),
      meta: {
        title: '草稿箱'
      }
    },
    {
      path: 'normals',
      name: 'normals',
      component: () => import('@/views/codeTemplate/normals.vue'),
      meta: {
        title: '普通模板库'
      }
    },
    {
      path: 'standards',
      name: 'standards',
      component: () => import('@/views/codeTemplate/standards.vue'),
      meta: {
        title: '标准模板库'
      }
    }
  ]
}
